import { inject, Injectable } from '@angular/core';
import { FormFieldModel, FormModel } from '@alfresco/adf-core';
import { BaseProcessor } from '../../base.processor';
import { GenerischeFreigabeVariables } from '../generische-freigabe.variables';
import { EbenFacade } from '@alf-nx-workspace/eben/data-access';
import { MatDialog } from '@angular/material/dialog';
import { EbenFormOutcomeModel } from '@alf-nx-workspace/eben/interfaces';

@Injectable({ providedIn: 'root' })
export class GenerischeFreigabeDokumentFreigebenProcessor extends BaseProcessor {

  static FORM_NAME = 'generische-freigabe-dokument-freigeben';
  public readonly FORM_NAME = GenerischeFreigabeDokumentFreigebenProcessor.FORM_NAME;

  readonly ebenFacade = inject(EbenFacade);
  readonly matDialog = inject(MatDialog);

  readonly ablehnenOutcomeName = 'GENERISCHE-FREIGABE.DOKUMENT-FREIGEBEN.OUTCOME.ABLEHNEN';
  readonly freigebenOutcomeName = 'GENERISCHE-FREIGABE.DOKUMENT-FREIGEBEN.OUTCOME.FREIGEBEN'
  readonly addApproverOutcomeName = 'GENERISCHE-FREIGABE.DOKUMENT-FREIGEBEN.OUTCOME.ADD-APPROVER';

  constructor(
  ) {
    super();
  }

  onLoaded(form:FormModel){
    super.onLoaded(form);
    const addApproverOutcome: EbenFormOutcomeModel = form.outcomes.find(o => o.name == this.addApproverOutcomeName);
    addApproverOutcome.isVisible = false;
  }

  onValidated(form: FormModel): void {
    super.onValidated(form);
  }

  onFieldValueChange(field:FormFieldModel){
    super.onFieldValueChange(field);
    if(field.id == GenerischeFreigabeVariables.additionalApprovers) {

      const value: unknown[] = JSON.parse(field.value);
      const hasValue = Array.isArray(value) && value.length > 0;

      const addApproverOutcome: EbenFormOutcomeModel = field.form.outcomes.find(o => o.name == this.addApproverOutcomeName);
      addApproverOutcome.isVisible = hasValue;
      this.ebenFormService.outcomeRefreshVisibility(addApproverOutcome);

      const freigebenOutcome: EbenFormOutcomeModel = field.form.outcomes.find(o => o.name == this.freigebenOutcomeName);
      freigebenOutcome.isVisible = !hasValue;
      this.ebenFormService.outcomeRefreshVisibility(freigebenOutcome);
    }
  }

}
